import dayjs, { Dayjs } from 'dayjs';

import MobileCalendarDate from '../types/MobileCalendarDate';

export const calendarDatesBetween = (
  calendarDates: MobileCalendarDate[],
  startDate: Dayjs,
  endDate: Dayjs | null,
): MobileCalendarDate[] =>
  calendarDates.filter((calendarDate) =>
    dayjs(calendarDate.date).isBetween(startDate, endDate, 'days', '[]'),
  );

export const getCourseInstancesBetweenDates = (
  calendarDates: MobileCalendarDate[],
  startDate: Dayjs | null,
  endDate?: Dayjs | null,
) => {
  if (!startDate) {
    return [];
  }

  if (!endDate) {
    return (
      calendarDates.find((calendarDate) =>
        dayjs(calendarDate.date).isSame(startDate, 'day'),
      )?.courseInstances ?? []
    );
  }

  return calendarDatesBetween(calendarDates, startDate, endDate).flatMap(
    (calendarDate) => calendarDate.courseInstances,
  );
};

export const getTimeSlotsBetweenDates = (
  calendarDates: MobileCalendarDate[],
  startDate: Dayjs | null,
  endDate?: Dayjs | null,
) => {
  if (!startDate) {
    return [];
  }

  if (!endDate) {
    return (
      calendarDates.find((calendarDate) =>
        dayjs(calendarDate.date).isSame(startDate, 'day'),
      )?.timeSlots ?? []
    );
  }

  return calendarDatesBetween(calendarDates, startDate, endDate).flatMap(
    (calendarDate) => calendarDate.timeSlots,
  );
};

export const formatSelectedDateRange = (
  start: Dayjs | null,
  end: Dayjs | null,
): string => {
  if (!start || !end) {
    return '';
  }

  const startFormat = start.isSame(end, 'month') ? 'D' : 'D MMMM';
  return `${start.format(startFormat)} - ${end.format('D MMMM')}`;
};
